import React from "react";

function AttachedFileDisplay() {
  return <div>AttachedFileDisplay</div>;
}

export default AttachedFileDisplay;
